import { useRoutes } from '@/shared/routes';

export const accessRoutes = [
  {
    path: useRoutes.ACCESS_ITEM_PATH,
    name: useRoutes.ACCESS_ITEM_NAME,
    component: () => import('@/pages/AccessItem'),
  },
  {
    path: useRoutes.ACCESS_LIST_PATH,
    name: useRoutes.ACCESS_LIST_NAME,
    component: () => import('@/pages/AccessList'),
  },
];
